import { c as _c } from "react/compiler-runtime";
import type { ApiNodeData, PublicTraceEntry } from '@onefootprint/request-types/dashboard';
import useStore from './use-store';
export const useGetTraceContext = (nodeId, nodeKind) => {
  const $ = _c(3);
  const {
    data: t0
  } = useStore();
  const {
    traceEntries
  } = t0;
  let t1;
  if ($[0] !== nodeId || $[1] !== traceEntries) {
    t1 = traceEntries?.find(e => e.decisionNodeId === nodeId);
    $[0] = nodeId;
    $[1] = traceEntries;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const entry = t1;
  if (!entry) {
    return;
  }
  if (!entry.context || entry.context.kind !== nodeKind) {
    return;
  }
  return entry;
};